export default __webpack_public_path__ + "static/media/logo.bfd63967.svg";